<template>
<div class="product-module">
    <ProductPreview :is_own_page="true" />
    <ProductContentTabs />
    <div class="product-module__recommended">
        <ProductGroup :title="'You Might Also Like'" :products="site_data.might_likes" />
        <ProductGroup :title="'Cross Sell Products'" :products="site_data.related_products" />
        <ProductGroup :title="'Brand\'s other Products'" :products="site_data.brand_siblings" />
    </div>
</div>
</template>

<script>
import ProductContentTabs from '../blocks/elements/ProductContentTabs';
import ProductGroup from '../blocks/ProductGroup';
import ProductPreview from '../blocks/ProductPreview';
export default {
    name        :   'ProductPage',
    components  :   {
        ProductContentTabs  :   ProductContentTabs,
        ProductPreview      :   ProductPreview,
        ProductGroup        :   ProductGroup
    },
    computed    :   {
        site_data()
        {
            return this.$store.state.site_data;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ProductPage.vue